import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

const useStyles = makeStyles(() => ({
  field: {
    height: 60,
    width: 500
  },
  title: {
    height: 50,
    width: 500
  }
}));

export default function SkeletonLaboratoryGrid({className}) {
  const classes = useStyles();
  return (
    <Grid className={className} container justifyContent='space-evenly' spacing={10}>
      <Grid item>
        <Grid container direction='column' spacing={1}>
          <Grid item>
            <Skeleton className={classes.title} variant="text" />
          </Grid>
          <Grid item>
            <Grid container direction='column' spacing={1}>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction='column' spacing={1}>
          <Grid item>
            <Skeleton className={classes.title} variant="text" />
          </Grid>
          <Grid item>
            <Grid className={classes.columnContainer} container direction='column' spacing={1}>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
              <Grid item>
                <Skeleton className={classes.field} variant="rect" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}